import { render, staticRenderFns } from "./PropertyTitle.vue?vue&type=template&id=49efd589&"
import script from "./PropertyTitle.vue?vue&type=script&lang=js&"
export * from "./PropertyTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49efd589')) {
      api.createRecord('49efd589', component.options)
    } else {
      api.reload('49efd589', component.options)
    }
    module.hot.accept("./PropertyTitle.vue?vue&type=template&id=49efd589&", function () {
      api.rerender('49efd589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertyTitle.vue"
export default component.exports